import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { countryList } from "./country-list";

interface LocationSelectionProps {
    topLabel: string;
    countryName: string;
    buttonLabel: string;
}

const Template = (args: LocationSelectionProps) =>
    html`<div class="ux-row">
        <div class="ux-col-12 ux-col-md-10 ux-u-offset-md-1 ux-u-my-xxs">
            <ux-iws-location-selection
                top-label="${args.topLabel}"
                country-name="${args.countryName}"
                button-label="${args.buttonLabel}"
            >
                ${countryList(false)}
            </ux-iws-location-selection>
        </div>
    </div>`;

export default {
    title: "Components/Location Selection",
    component: "ux-iws-location-selection",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    argTypes: {
        topLabel: { control: "text" },
        countryName: { control: "text" },
        buttonLabel: { control: "text" },
    },
};

export const Default = Template.bind({});
Default.args = {
    topLabel: "Locations in",
    countryName: "Germany",
    buttonLabel: "Change country",
};
